import React from 'react';


import regentaenzer from "../../assets/Regentaenzer.png";


export const Kontakt = () => {
    return (
        <section className='portfolio-mf sect-pt4 route' id='contact'>
            <main>


                <div className='text-card-container'>
                <h1 className='section-header'>Label & Management</h1>

                    

                <div className="row">
                <div className="col-sm-12">
                            <img 
                                 src={regentaenzer} className="responsive-img" style={{maxHeight: '150px'}}
                            />
                            <br/>
                            <span><a href="mailto:label@regentaenzer.com">label@regentaenzer.com</a></span>
                            <br/>
                            <span>+49 176 500 78 544</span>
                        </div>

                    </div>
                    </div>
            </main>

        </section>

    );
}